import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import {
  formatAssessmentBonusSuffix,
  formatAssessmentScoreNumber,
  getAssessmentBaseScore,
} from "../../utils/assessmentScore";

interface AssessmentScoreInlineProps {
  score: number;
  maxScore: number;
  bonusScore?: number;
  sx?: SxProps<Theme>;
  bonusSx?: SxProps<Theme>;
}

// One-line score: `12/60` + smaller bold `(+ 3 bonus)`.
export const AssessmentScoreInline = ({
  score,
  maxScore,
  bonusScore = 0,
  sx,
  bonusSx,
}: AssessmentScoreInlineProps) => {
  const base = getAssessmentBaseScore(score, bonusScore);
  const main =
    maxScore > 0
      ? `${formatAssessmentScoreNumber(base)}/${formatAssessmentScoreNumber(maxScore)}`
      : formatAssessmentScoreNumber(base);
  const bonusLabel = formatAssessmentBonusSuffix(bonusScore).trim();

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "baseline",
        flexWrap: "nowrap",
        whiteSpace: "nowrap",
        ...sx,
      }}
    >
      <Box component="span">{main}</Box>
      {bonusLabel ? (
        <Box
          component="span"
          sx={{
            ml: 0.5,
            fontSize: "0.62em",
            fontWeight: 700,
            lineHeight: 1,
            ...bonusSx,
          }}
        >
          {bonusLabel}
        </Box>
      ) : null}
    </Box>
  );
};

export default AssessmentScoreInline;
